import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import apiClient from '../../apiClient';
import './CustomerForm.scss';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';
import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';

const customerColumns = [{ title: 'Customer Name', field: 'CustomerName' }];
const customerCsvHeaders = [{ label: 'Customer Name', key: 'CustomerName' }];

class CustomerForm extends React.Component {
    state = {
        formData: {
            customername: ''
        },
        submitted: false,
        successMessage:null,
        errorMessage:null,
        listVersion: 0,
    }

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    componentDidMount() {
      sessionStorage.setItem('TranSearch', null);
      sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
        let user = JSON.parse(sessionStorage.getItem('user'));
         if(user.permissions.filter(x=>x.PermissionName == 'Customer' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }

		
      }

    handleSubmit = () => {
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = user.accessToken;

        const { formData } = this.state;
        const params = {
            tablename:  'customers' ,
            queryvalue: formData.customername
          };

        apiClient.get(`/api/get/checkduplicateexist`  ,  { params: params ,headers: {"Authorization" : `Bearer ${accessToken}`} })
            .then(res => {
                if(res.data == 'duplicate')
                {
                    this.setState({ errorMessage: 'Customer already exist, Please enter another customer.' });

                    
                    setTimeout(() => {
                    this.setState({ errorMessage: null });
                    }, 10000);

                }else{

                    
                        this.setState({ submitted: true }, () => {
                            setTimeout(() => this.setState({ 
                                formData: {
                                    customername: ''
                                },
                                submitted: false
                            }), 2000);
                        });

                        /**
                         * POST REQUEST
                         */
                       
                       

                        apiClient.post(`/api/post/customer`, { formData }, { headers: {"Authorization" : `Bearer ${accessToken}`} })
                    .then(res => {
                        const result = res.data;
                        this.setState({ result });
                        this.setState({ successMessage: 'Successfully saved!' });

                    
                        setTimeout(() => {
                        this.setState({ successMessage: null });
                        }, 3000);

                        this.setState((state) => ({ listVersion: state.listVersion + 1 }));
                    })
                    .catch(error => notifyApiError(
                      this.props.showFlashNotification,
                      error,
                      'Unable to save customer.'
                    ));

                }
           

            })
            .catch(error => notifyApiError(
              this.props.showFlashNotification,
              error,
              'Unable to check whether the customer already exists.'
            ));




    }

    render() {
        const { formData, submitted } = this.state;
        return (
        <div className="CustomerForm">
          
                  
            <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
            >
                <h2>Customer Form</h2>
                <TextValidator
                    label="Customer Name"
                    onChange={this.handleChange}
                    name="customername"
                    value={formData.customername}
                    validators={['required']}
                    errorMessages={['this field is required']}
                />
                
               
               
                <br /><br /><br />
                <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={submitted}
                >
                    {
                        (submitted && 'Your form is submitted!')
                        || (!submitted && 'Submit')
                    }
                </Button>

                 
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}
        {this.state.errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {this.state.errorMessage}
        </div>
      )}
            </ValidatorForm>
            <SharedDetails
              columns={customerColumns}
              csvFilename="customer-details.csv"
              csvHeaders={customerCsvHeaders}
              emptyMessage="No customer records found."
              errorMessage="Unable to load customers. Please try again."
              loadingMessage="Loading customers..."
              pagedEndpoint="/api/get/customer/paged"
              reloadKey={this.state.listVersion}
              style={{ maxWidth: '100%', paddingTop: '50px' }}
              title="Customer Details"
            />
         </div>
        
        );
    }
}

export default withFlashNotification(CustomerForm);
